import React, { useState } from 'react';

const SponsorLogoMarquee = ({ sponsors }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Filter out ad cards and get only sponsors with logos
  const sponsorsWithLogos = sponsors.filter(sponsor => 
    sponsor.logo_url && 
    sponsor.logo_url !== '' && 
    !(sponsor.is_ad_card === 1 || sponsor.is_ad_card === true || sponsor.tier === 'reklam-alani')
  );

  if (sponsorsWithLogos.length === 0) return null;

  const handleLogoClick = (sponsor) => {
    if (sponsor.button1_link || sponsor.button1Link) {
      const link = sponsor.button1_link || sponsor.button1Link;
      if (link && link !== '#' && link !== '') {
        if (link.startsWith('http://') || link.startsWith('https://')) {
          window.open(link, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = link;
        }
      }
    } else if (sponsor.website_url || sponsor.websiteUrl) {
      const link = sponsor.website_url || sponsor.websiteUrl;
      if (link && link !== '#' && link !== '') {
        if (link.startsWith('http://') || link.startsWith('https://')) {
          window.open(link, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = link;
        }
      }
    }
  };

  return (
    <div className="relative overflow-hidden bg-navy-900/90 border-b border-gold/20 py-3 sm:py-4 sticky top-0 z-20 group">
      <div 
        className={`flex animate-scroll-infinite ${hoveredIndex !== null ? 'pause-scroll' : ''}`}
        style={{ width: 'max-content' }}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        {/* 3 set tekrarla - seamless infinite loop için */}
        {[...Array(3)].map((_, setIndex) => (
          sponsorsWithLogos.map((sponsor, index) => (
            <div
              key={`set-${setIndex}-${sponsor.id}-${index}`}
              className="flex-shrink-0 mx-3 sm:mx-4 md:mx-6 group/item"
              onMouseEnter={() => setHoveredIndex(`logo-${sponsor.id}-${setIndex}-${index}`)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => handleLogoClick(sponsor)}
            >
              <div
                className={`flex items-center justify-center h-12 sm:h-16 md:h-20 w-24 sm:w-32 md:w-40 px-2 sm:px-4 cursor-pointer transition-all duration-300 active:scale-95 transform-gpu ${
                  hoveredIndex === `logo-${sponsor.id}-${setIndex}-${index}` 
                    ? 'scale-110 z-20' 
                    : hoveredIndex !== null 
                    ? 'opacity-20 blur-md scale-95' 
                    : ''
                }`}
                style={{
                  filter: hoveredIndex === `logo-${sponsor.id}-${setIndex}-${index}`
                    ? 'drop-shadow(0 10px 20px rgba(212, 175, 55, 0.6))'
                    : hoveredIndex !== null
                    ? 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))'
                    : 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))'
                }}
              >
                <img
                  src={sponsor.logo_url.startsWith('http') ? sponsor.logo_url : sponsor.logo_url}
                  alt={sponsor.name}
                  className={`max-h-full max-w-full object-contain relative z-10 transition-all duration-300 ${
                    hoveredIndex === `logo-${sponsor.id}-${setIndex}-${index}` 
                      ? 'brightness-110 scale-110' 
                      : ''
                  }`}
                  style={{
                    willChange: 'transform, filter',
                    opacity: hoveredIndex === null || hoveredIndex === `logo-${sponsor.id}-${setIndex}-${index}` ? 1 : (hoveredIndex !== null ? 0.2 : 0.9)
                  }}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          ))
        ))}
      </div>
      {/* Gradient fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-navy-900/90 via-navy-900/80 to-transparent pointer-events-none z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-navy-900/90 via-navy-900/80 to-transparent pointer-events-none z-10" />
    </div>
  );
};

export default SponsorLogoMarquee;
